module.exports = __webpack_public_path__ + "assets/img/5_1381_big.0b8de6ca.jpg";